import { api } from '../api';

export interface Participant {
  eventTitle: string;
  id: string;
  name: string;
  email: string;
  cpf: string;
  ticket_type: string;
  ticket_value: string;
  event_id: string;
  created_at: string;
  payment_status: 'open' | 'confirmed' | 'paid' | 'refunded' | 'desistente';
  payment_method: 'card' | 'pix' | 'cash' | 'boleto'| null;
  dynamicAnswers?: Array<{
    question: string;
    answer: string;
  }>;
  event?: {
    label_ingresso_inteiro?: string;
    label_ingresso_meia?: string;
    label_ingresso_estudante?: string;
    label_ingresso_crianca?: string;
  };
  installments?: Array<{
    id: string;
    installment_number: number;
    total_installments: number;
    value: number;
    due_date: string;
    status: string;
    paid_at?: string;
  }>;
  // Campos de cupom de desconto
  coupon_id?: string;
  discount_applied?: string;
  original_ticket_value?: string;
}
export interface PixInfoResponse {
  success: boolean;
  status?: string;
  message?: string;
  encodedImage: string;
  payload: string;     
  expirationDate: string;
  value?: number;
  paymentId?: string;
}

export interface CardPaymentRequest {
  cpf: string;
  eventId: string;
  installmentCount: number;
  creditCardToken: string;
}

export interface CardPaymentResponse {
  message: string;
  payment: {
    id?: string;
    status?: string;
    value?: number;
    error?: string;
    details?: any;
    bankSlipUrl?: string;
    [key: string]: any;
  };
}
export interface BoletoPaymentRequest {
  cpf: string;
  eventId: string;
  installmentCount: number;
  description: string;
  externalReference: string;
}

export interface BoletoPaymentResponse {
  message: string;
  payment: {
    id: string;
    status: string;
    value: number;
    bankSlipUrl: string;
  };
  bankSlipUrl: string;
}
export const visitorService = {
  listParticipantsByEvent: async (eventId: string, page = 1, limit = 15, name?: string) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(name && { name })
    });

    const response = await api.get(`/participants/event/${eventId}?${params.toString()}`);
    return response.data;
  },
  getById: async (id: string) => {
    const response = await api.get(`/participants/${id}`);
    return response.data.participant;
  },
  update: async (id: string, data: any) => {
    return api.put(`/participants/${id}`, data);
  },
  register: async (data: any) => {
    return api.post(`/participants`, data);
  },
  confirmPayment: async (id: string, payment_method: 'card' | 'pix' | 'cash') => {
    return api.post(`/participants/${id}/confirm-payment`, { payment_method });
  },
  cardPayment: async (data: CardPaymentRequest): Promise<CardPaymentResponse> => {
    const response = await api.post(`/participants/card-payment`, data);
    return response.data;
  },
  pixInfo: async (cpf: string, eventId: string): Promise<PixInfoResponse> => {
    const cpfReplace = cpf.replace(/\D/g, ''); 
    const response = await api.get(`/participants/pix-info?cpf=${cpfReplace}&eventId=${eventId}`);
    return response.data;
  },
  boletoPayment: async (data: BoletoPaymentRequest): Promise<BoletoPaymentResponse> => {
    const response = await api.post(`/participants/boleto-payment`, data);
    return response.data;
  },
  getAsaasCustomerByCpf: async (cpf: string): Promise<{ id: string }> => {
    const cpfReplace = cpf.replace(/\D/g, '');
    const response = await api.get(`/participants/asaas/customer-by-cpf?cpf=${cpfReplace}`);
   
    return response.data?.customer?.data;
  },

  /**
   * 🎯 Atualiza as respostas dinâmicas de um participante
   * - Adiciona respostas que estavam faltando
   * - Atualiza respostas existentes
   * - NÃO deleta respostas que não foram enviadas
   */
  updateDynamicAnswers: async (
    participantId: string,
    dynamicAnswers: Array<{ dynamic_field_id: string; answer: string }>
  ) => {
    const response = await api.put(`/participants/${participantId}/dynamic-answers`, {
      dynamicAnswers,
    });
    return response.data;
  },
  /**
   * 🚫 Marca participante como desistente
   * Só pode ser aplicado se payment_status for 'open'
   */
  markAsDesistente: async (participantId: string) => {
    const response = await api.patch(`/participants/${participantId}/mark-desistente`);
    return response.data;
  },
};